import React from "react";
import {Spring} from 'react-spring/renderprops';


function SuppedPrice(props) {

    let decimalPart = Math.floor(props.number);
    let fractionPart = Number.parseFloat(props.number - decimalPart).toFixed(2).substring(2);

    if (fractionPart === '00') {
        if (props.force === false) {
            fractionPart = '';
        }
    }
    let unit = '';
    if (props.unit) {
        unit = props.unit;
    }


    return  (
        <span className={"supped-price digits-" + (decimalPart.toString().length) + ((fractionPart !== '') ? ' has-fraction' : '') }>
            {props.anim ? (
                <Spring
                    from={{ decimal: 0, fraction: 0 }}
                    to={{ decimal: decimalPart, fraction: fractionPart }}>
                    {props =>
                        <>
                        {unit}{props.decimal.toFixed(0)}
                            {props.fraction !== '' &&
                            <>
                                .<sup>{(props.fraction < 10) ? '0' : ''}{props.fraction.toFixed(0)}</sup>
                            </>
                            }
                        </>
                    }
                </Spring>
            ) : (
                <>
                    {unit}{decimalPart}
                    {fractionPart !== '' &&
                        <>
                            .<sup>{(fractionPart === 0)? '00' : fractionPart}</sup>
                        </>
                    }
                </>
            )}


        </span>
    );
}

export { SuppedPrice };